<template>
  <div class="good-item">
    <div style="">
      <div class="good-img">
        <a @click="openProduct(msg.id)">
          <img v-lazy="msg.image" :alt="msg.storeName" :key="msg.image">
        </a>
      </div>
      <h6 class="good-title" v-html="msg.storeName">{{msg.storeName}}</h6>
<!--      <h3 class="sub-title ellipsis">{{msg.specDescr}}</h3>-->
      <div class="good-price pr">
        <div class="ds pa">
          <a @click="openProduct(msg.id)">
            <y-button text="查看详情" style="margin: 0 5px"></y-button>
          </a>
          <y-button text="加入购物车"
                    style="margin: 0 5px"
                    @btnClick="addCart(msg)"
                    classStyle="main-btn"
          ></y-button>
        </div>
        <p><span style="font-size:14px">￥</span>{{msg.price}}
          <span style="font-size:14px;color: #999;text-decoration: line-through;font-weight: 400;">￥{{msg.otPrice}}</span></p>
      </div>
    </div>
  </div>
</template>
<script>
  import YButton from '/components/YButton'
  import { mapMutations, mapState } from 'vuex'
  import {cartAdd} from '/api/cart'
  export default {
    props: {
      msg: {
        salePrice: 0
      }
    },
    data () {
      return {}
    },
    methods: {
      ...mapMutations(['ADD_CART', 'ADD_ANIMATION', 'SHOW_CART']),
      goodsDetails (id) {
        if (this.login) {
          // 登录了，直接跳转详情页面
          this.$router.push({path: 'goodsDetails/productId=' + id})
        } else {
          this.$router.push({
            path: '/login'
          })
        }
      },
      openProduct (id) {
        if (this.login) {
          // 登录了，直接跳转详情页面
          window.open('//' + window.location.host + '/#/goodsDetails?productId=' + id)
        } else {
          this.$router.push({
            path: '/login'
          })
        }
      },
      addCart (msg) {
        if (!this.showMoveImg) {     // 动画是否在运动
          let unique = msg.productValue[msg.productAttr[0].attrValue[0].attr].unique
          let sku = msg.productValue[msg.productAttr[0].attrValue[0].attr].sku
          console.log('sku--->', sku)
          if (this.login) { // 登录了 直接存在用户名下
            let params = {
              productId: msg.id,
              cartNum: 1,
              secKillId: 0,
              uniqueId: unique
            }

            cartAdd(params).then(res => {
              // 并不重新请求数据
              if (res.status === 200) {
                this.ADD_CART({
                  id: res.data.cartId,
                  productId: msg.id,
                  salePrice: msg.price,
                  productName: msg.storeName,
                  productImg: msg.image,
                  productNum: 1,
                  secKillId: 0,
                  uniqueId: unique,
                  sku: sku
                })
              } else {
                this.$message.warning(res.msg)
              }
            })

            // addCart({userId: getStore('userId'), productId: id, productNum: 1}).then(res => {
            //   // 并不重新请求数据
            //   this.ADD_CART({productId: id, salePrice: price, productName: name, productImg: img})
            // })
          } else { // 未登录 vuex
            this.ADD_CART({
              productId: msg.id,
              salePrice: msg.price,
              productName: msg.storeName,
              productImg: msg.image,
              productNum: 1,
              secKillId: 0,
              uniqueId: unique,
              sku: sku
            })
            // this.ADD_CART({productId: id, salePrice: price, productName: name, productImg: img})
          }
          // 加入购物车动画
          var dom = event.target
          // 获取点击的坐标
          let elLeft = dom.getBoundingClientRect().left + (dom.offsetWidth / 2)
          let elTop = dom.getBoundingClientRect().top + (dom.offsetHeight / 2)
          // 需要触发
          this.ADD_ANIMATION({moveShow: true, elLeft: elLeft, elTop: elTop, img: msg.image})
          if (!this.showCart) {
            this.SHOW_CART({showCart: true})
          }
        }
      }
    },
    computed: {
      ...mapState(['login', 'showMoveImg', 'showCart'])
    },
    mounted () {
    },
    components: {
      YButton
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
  @import "../assets/style/mixin";
  @import "../assets/style/theme";

  .good-item {
    background: #fff;
    width: 25%;
    transition: all .5s;
    height: 400px;
    &:hover {
      transform: translateY(-3px);
      box-shadow: 1px 1px 20px #999;
      .good-price p {
        display: none;
      }
      .ds {
        display: flex;
      }
    }
    .ds {
      @extend %block-center;
      width: 100%;
      display: none;
    }

    .good-img {
      img {
        margin: 50px auto 10px;
        @include wh(206px);
        display: block;
      }
    }
    .good-price {
      margin: 15px 0;
      height: 30px;
      text-align: center;
      line-height: 30px;
      color: #d44d44;
      font-family: Arial;
      font-size: 18px;
      font-weight: 700;
    }
    .good-title {
      line-height: 1.2;
      font-size: 16px;
      color: #424242;
      margin: 0 auto;
      padding: 0 14px;
      text-align: center;
      overflow: hidden;
      white-space:nowrap;
      text-overflow:ellipsis;
    }
    h3 {
      text-align: center;
      line-height: 1.2;
      font-size: 12px;
      color: #d0d0d0;
      padding: 10px;
    }

  }

  .collect {
    position: absolute;
    top: 0px;
    right: 0px;
  }

  .collect-img {
    position: absolute;
    top: -50px;
    left: -25px;
  }
</style>



// WEBPACK FOOTER //
// mallGoods.vue?c9a92714